<div class="sizing-root">
  <div class="sizing-toolbar">
    <div class="left">
      <div class="tabs">
        <span class="tab" [class.active]="currentView === SizingViewMode.FORM" (click)="switchView(SizingViewMode.FORM)">
          {{'CUSTOM_IMAGES.FORM' | transloco}}
        </span>
        <span class="vertical-divider"></span>
        <span class="tab" [class.active]="currentView === SizingViewMode.JSON" (click)="switchView(SizingViewMode.JSON)">
          {{'CUSTOM_IMAGES.JSON' | transloco}}
        </span>
      </div>

      <div class="search-box">
        <input class="fs-14 fw-500" type="text" placeholder="Search" [(ngModel)]="searchTerm" (input)="onSearchInput()" />
        <mat-icon class="icon-search" svgIcon="search"></mat-icon>
      </div>
      @if (templateResponse) {
        <button class="download-btn" (click)="downloadJson()">
          <mat-icon svgIcon="file_download"></mat-icon>
          {{'CUSTOM_IMAGES.DOWNLOAD_JSON' | transloco}}
        </button>
      }
    </div>
  </div>

  <div *ngIf="currentView === SizingViewMode.FORM">
    <div class="sizing-body">
      @if (!templateResponse && ( !searchTerm || (sizingCards?.length === 0 && searchTerm?.trim()))) {
        <div class="no-results">
          <img src="assets/images/no-template.png" alt="No Results" />
          <div class="no-results-text">{{'SIZING.NO_RECORD' | transloco }}</div>
        </div>
      }  @else {
        @if (sizingCards?.length === 0 && searchTerm?.trim()) {
          <div class="no-results"> 
            <img src="assets/images/no_result.svg" alt="No Results" />
            <div class="no-results-text">{{'COMMON_MESSAGE.NO_RESULTS_FOUND' | transloco }}</div>
          </div>
        } @else {
      <div *ngFor="let card of sizingCards" class="sizing-card">
        <div class="card-header floating">
          <span class="fs-10 fw-700 pill pill-transact">{{ card.title }}</span>
          <span class="fs-10 fw-700 pill pill-database">{{ card.component }}</span>
        </div>
        <div *ngFor="let section of card.sections; let last = last" class="section">
          <div class="section-title fs-14 fw-700">
            {{ section.sectionTitle }}
          </div>
          <div class="metrics-row">
            <div *ngFor="let metric of section.metrics" class="metric">
              {{ metric.label }}: {{ metric.value }}
            </div>
          </div>
          <div *ngIf="!last" class="divider-line"></div>
        </div>
      </div>
      }
      @if(!validSchema && componentError && !searchTerm) {
        <div class="no-results">
          <div class="flex flex-col items-center">
            <mat-icon svgIcon="warning_amber" class="w-48 h-48 amber_color"></mat-icon>
            <div class="mat-subtitle-2 fs-16 fw-600 mt-16">{{'SIZING.VALIDATE_MESSAGE1' | transloco }}</div>
            <div class="mat-subtitle-2 fs-16 fw-600 mt-16">{{'SIZING.VALIDATE_MESSAGE2' | transloco }}</div>
            <span class="agent-link mat-body-2 mt-24" (click)="viewErrorDetails.emit(false)">{{'SIZING.VIEW_DETAILS'| transloco}}</span>
          </div>
        </div>
      }     
      @if(retrySizing) {
          <div class="no-results">
                  <div class="flex flex-col items-center">
                      <mat-icon svgIcon="warning_amber" class="w-48 h-48 amber_color"></mat-icon>
                      <div class="mat-subtitle-2 fs-16 fw-600 mt-16 mr-8">{{'SIZING.SIZING_VALIDATION' | transloco }}</div>
                      <div class="flex flex-row justify-center items-center mt-24">
                          <button class="white mr-20 report-letter-spacing" type="button" (click)="startSizingProcess()"> {{ 'ERROR_DIALOG.RETRY' | transloco }} </button>
                          <button class="error-report-bg-color accent report-letter-spacing" type="button" (click)="openContactForm()"> {{ 'ERROR_DIALOG.REPORT' | transloco }} </button>
                      </div>
                  </div>
              </div>
          }
    }
    </div>
  </div>

  <div *ngIf="currentView === SizingViewMode.JSON" class="json-view">
    <div class="editor-container">
      <ngx-monaco-editor
        *ngIf="!isJsonLoading"
        [options]="editorOptions"
        [model]="jsonInput"
        class="editor">
      </ngx-monaco-editor>
    </div>
    <div *ngIf="isJsonLoading" class="editor-loader">
      <mat-spinner diameter="18"></mat-spinner>
    </div>
  </div>
</div>
